// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    apiURL: 'developmentApi',
    timeoutMinutes: 100,
    homeURL: '/',
    loginURL: '/ACLFilenetServices/v1/ACLServices/login?forLogin',
    resetURL: '/UserManagementWeb/rest/sendresetemail',
    passwordURL: '/UserManagementWeb/rest/resetmypassword',
    userManagementURL: '/UserManagementWeb/rest/',
    logoutURL: '/#/Logout',
    IBMLogoutURL: '/ACLFilenetServices/ibm_security_logout',
    logonURL: '/ACL/#/Login',
    helpURL: '/aclhelp',
    dateFormat: 'yyyy/MM/dd',
    filenetURL: '/i1FilenetServices2/v1/FilenetServices',
    fileWarnSize: 10,
    contractFormURL: '/ACLFilenetServices/v1/ACLServices/createContract',
    batchUploadURL: '/ACLFilenetServices/v1/ACLServices/batchUpload',
    boUploadURL: '/ACLServices-web/api/rest/v1/ACL/uploadBusinessOwner',
    reportRoot: '/ACLFilenetServices/v1/ACLReports/',
    serviceURL_ACL: '/ACLFilenetServices/v1/ACLServices',
    deleteUserURL: '/ACLFilenetServices/v1/ACLServices/deleteAllUserAccess',
    usersGroup: 'ACL Users',
    noLimitSearch: 2000,
    limitSearch: 200,
    limitReportLibrary: 20
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
